import '@fontsource/open-sans';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import React from 'react';

export const onRenderBody = ({ setHeadComponents }) => {
  setHeadComponents([
    <script
      key="google-adsense"
      async
      src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1439386874209468"
      crossOrigin="anonymous"
    />,
  ]);
};

